'use client';
import GloLayout from 'lowcode/common/GloLayout';
import FullScreenModal from 'lowcomp/plugins/member/common/FullScreenModal';
import RewardsRedeemed from 'lowcomp/plugins/member/common/RewardsRedeemed';
import { useEffect, useState } from 'react';
import { useMemberTimeStore } from 'lowcode/utils/context/memberTimeZone';
import { config } from '../config';
import { getLang, injectNotes } from '../../utils';
import { textLang } from '../../common/textLang';
import styles from './index.module.scss';
import LuckyTurntable from './components';
import { LuckyProvider } from './components/LuckyProvider';
import { getIsLogin } from '@/utils/cookie';
import { getIssuedCoupons } from '@/service/vip';
import getLocal from '@/app/utils/getLocal';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { locale } = getLocal();
    const t = getLang(textLang, locale);
    const [isLogin, setIsLogin] = useState(false);
    const [showPage, setShowPage] = useState('basic'); // basic / history_modal / coupon_modal / points_modal / bouns_modal / qhistory_modal / lucky_history
    const [issuedCoupon, setIssuedCoupon] = useState<any[]>([]);
    const { timezoneList } = useMemberTimeStore();

    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
    }, []);

    const { backgroundColor, themeColor, bgImage, mobileBgImage, kvImage, titleColor, subTitleColor, frontImage, backImage, prizeFontColor, loginType } = data;
    const { defaultData } = config;
    const styleOption: any = {
        '--member-flop-background': backgroundColor || defaultData.backgroundColor,
        '--member-flop-title': titleColor || defaultData.titleColor,
        '--member-flop-theme': themeColor || defaultData.themeColor,
        '--member-flop-subtitle': subTitleColor || defaultData.subTitleColor,
        '--member-flop-prizefont': prizeFontColor || defaultData.prizeFontColor,
    };

    /**
     * 查询issued优惠券兑换记录
     */
    const queryIssuedRewards = async () => {
        const res = await getIssuedCoupons(locale);
        if (res?.code === '0') {
            const coupons = injectNotes(res?.data || [], t, locale, timezoneList);
            setIssuedCoupon(coupons || []);
        }
    };

    return (
        <GloLayout id={id} className={`temp-questions ${styles.content}`}>
            <LuckyProvider>
                <div style={styleOption} className="GtmModuleData-section" data-section-id={'Member-FlopGame'} data-section-title={'Member-FlopGame'}>
                    <LuckyTurntable
                        id={data.id}
                        isEditStatus={isEditStatus}
                        isLogin={isLogin}
                        loginType={loginType}
                        setShowPage={setShowPage}
                        imgConfig={{
                            bgImage: bgImage || defaultData.bgImage,
                            mobileBgImage: mobileBgImage || defaultData.mobileBgImage,
                            kvImage: kvImage || defaultData.kvImage,
                            frontImage: frontImage || defaultData.frontImage,
                            backImage: backImage || defaultData.backImage,
                        }}
                    />
                </div>
                {/* 优惠券弹窗 */}
                {showPage?.startsWith('coupon_modal') && (
                    <FullScreenModal
                        visible={showPage?.startsWith('coupon_modal')}
                        className={showPage}
                        style={{ background: '#f8f8f8' }}
                        closeModal={() => setShowPage('')}
                        afterOpen={() => {
                            queryIssuedRewards();
                        }}
                    >
                        <RewardsRedeemed modal defaultSelectKey={(showPage?.includes('$') && showPage?.split('$').pop()) || '1'} issuedCoupon={issuedCoupon} />
                    </FullScreenModal>
                )}
            </LuckyProvider>
        </GloLayout>
    );
}
